// extracted by mini-css-extract-plugin
module.exports = {"content":"OldUserConfirmPage_content__12F81"};